export const ROUTE_APP_EMPTY = "/";
export const ROUTE_APP_QUOTATION = "/cotizacion";
export const ROUTE_APP_SUMMARY = "/resumen";
export const ROUTE_APP_CARD_PAYMENT_CONFIRMATION = "/confirmacion";
